/**
 * 장비 가격표 (/adm/car-prices?cartype=…) — 차종·태그별 거리×시간 가격 행렬 편집, 옵션 가격 모달, 엑셀 붙여넣기
 * ($j.Pages.Admin.CarPrice / body data-page-name="CarPrice")
 *
 * 차종·관리자 레벨은 #page-data 로 받는다. window 에 함수를 내놓지 않는다.
 */
export default class CarPrice {
    initialize() { initialize(); }
}

// 서버 값 (컨트롤러 $pageData → #page-data) — initialize 가 채운다
var managerLoginLevel = 0;
var carType = '';
var tag = '';
var tagList = {
    '': '장비불러',
    '삼성': '삼성(수주자)',
    '삼성B': '삼성(발주자)',
    'LG': 'LG',
    '경원': '경원',
    '머큐리1': '머큐리1 지사',
    '머큐리2': '머큐리(전국화물공제조합) 지사',
    '제너텍': '제너텍',
    '아라텍': '아라텍'
};

class CarPriceTracker {
    constructor() { this.db = {}; }
    static getInstance() {
        if (!CarPriceTracker._instance) CarPriceTracker._instance = new CarPriceTracker();
        return CarPriceTracker._instance;
    }
    update(id, price) { this.db[id] = price; }
    isChanged(id, p) { return this.db[id] != p; }
    getPrice(id) { return this.db[id]; }
    reset() { this.db = {}; }
}

var $price = CarPriceTracker.getInstance();

function initialize(){
    const d = JSON.parse(document.getElementById('page-data').textContent);
    managerLoginLevel = d.level;
    carType = d.carType;

    $('#btn-load-matrix').on('click', loadMatrix);
    $('#fold_chk').on('click', toggleNightColumns);
    $('#btn-edit-excel').on('click', editExcel);
    $('#btn-save-price').on('click', checkSubmit);
    // 옵션 버튼(loadMatrix 가 다시 그린다) — 번호·가격방식·이름은 data-* 로
    $('#option-buttons').on('click', '.opt-btn', function(){
        editOption(this.dataset.num, this.dataset.priceType, this.dataset.name);
    });

    initPage();
    initHandler();
}

function initPage(){
    setActiveTab(carType);
    initTagSelect();
    loadMatrix();
}
function initHandler(){
    $('#car-type-tabs').on('click', '.car-type-tab', function(e){
        e.preventDefault();
        setActiveTab($(this).data('cartype'));
        loadMatrix();
    });
}

function setActiveTab(type){
    var $tabs = $('#car-type-tabs .car-type-tab');
    var $target = $tabs.filter('[data-cartype="' + type + '"]');
    if (!$target.length) $target = $tabs.first();
    $tabs.removeClass('active');
    $target.addClass('active');
    carType = $target.data('cartype');
}



function initTagSelect(){
    var html = '';
    $.each(tagList, function(key, label){
        html += `<option value="${key}">${label}</option>`;
    });
    $('#tag-select').html(html);
}

function loadMatrix(){
    carType = $('#car-type-tabs .car-type-tab.active').data('cartype');
    tag = $('#tag-select').val();

    $.ajax({
        type: 'POST',
        url: '/adm/ajax/car-prices/matrix',
        data: { car_type: carType, tag: tag },
        dataType: 'json',
        success: function(data){
            renderTable(data.headers, data.rows);
            renderOptionButtons(data.options);
            $price.reset();
            initPriceTracking();
            setColumnBackColor();

            if (carType == '사다리') {
                $('#fold_chk').prop('checked', true);
                toggleNightColumns();
            } else {
                $('#fold_chk').prop('checked', false);
            }

            // 저장 버튼: level 10만
            if (managerLoginLevel >= 10) {
                $('#save-area').show();
            } else {
                $('#save-area').hide();
            }
        }
    });
}

function renderTable(headers, rows){
    var html = '<thead><tr>';
    for (var i = 0; i < headers.length; i++) {
        html += `<th id="head${i}">${headers[i]}</th>`;
    }
    html += '</tr></thead><tbody>';

    for (var r = 0; r < rows.length; r++) {
        html += '<tr>';
        for (var c = 0; c < rows[r].length; c++) {
            if (c == 0) {
                html += `<td title="${rows[r][c]}">${rows[r][c]}</td>`;
            } else {
                var parts = rows[r][c].split(',');
                var id = parts[0];
                var price = Math.floor(parseInt(parts[1]) / 1000);
                html += `<td><input id="pr_${id}" type="text" value="${price}" class="frm_input3" size="5" data-value="${c+1},${r+2}"></td>`;
            }
        }
        html += '</tr>';
    }
    html += '</tbody>';
    $('#price_table').html(html);
}

function renderOptionButtons(options){
    var html = '';
    for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var cls = opt.price_type ? 'has-price' : 'no-price';
        html += `<button type="button" class="opt-btn ${cls}" data-num="${opt.num}" data-price-type="${opt.price_type||''}" data-name="${$('<div>').text(opt.name).html().replace(/"/g, '&quot;')}">${opt.name}</button>`;
    }
    $('#option-buttons').html(html);
}

function initPriceTracking(){
    $('[id^="pr_"]').each(function(){
        var id = this.id.replace('pr_', '');
        $price.update(id, $(this).val());
    }).on('blur', function(){
        checkPriceValue($(this));
    });
}

function checkPriceValue($item){
    var id = $item.attr('id').replace('pr_', '');
    var price = $item.val();
    if (isNaN(price) || price.length > 5 || price.length == 0) {
        $item.val($price.getPrice(id));
        return;
    }
    if ($price.isChanged(id, price)) {
        $item.css('color', 'var(--adm-kw-red, red)');
    } else {
        $item.css('color', '');
    }
}

function checkSubmit(){
    var changedDb = [];
    $('[id^="pr_"]').each(function(){
        var id = this.id.replace('pr_', '');
        var price = $(this).val();
        if ($price.isChanged(id, price)) {
            changedDb.push(`${id}=${price}`);
        }
    });
    if (changedDb.length == 0) {
        $j.Common.Util.swalert('변경사항이 없습니다.');
        return;
    }
    var sendData = {
        car_type: carType,
        tag: tag,
        prices: changedDb.join('&')
    };
    $.ajax({
        type: 'POST',
        url: '/adm/ajax/skw_4002',
        data: sendData,
        dataType: 'json',
        success: function(){
            $j.Common.Util.swalert(['저장완료', 'success'], function(){
                loadMatrix();
            });
        }
    });
}

function toggleNightColumns(){
    var runFold = $('#fold_chk').is(':checked');
    $('#price_table').find('[id^="head"]').each(function(){
        if ($(this).html().indexOf('야간') != -1) {
            var colIdx = parseInt(this.id.replace('head', '')) + 1;
            var $cols = $(`#price_table tr > th:nth-child(${colIdx}), #price_table tr > td:nth-child(${colIdx})`);
            if (runFold) {
                $cols.hide();
            } else {
                $cols.show();
            }
        }
    });
}

function setColumnBackColor(){
    $('#price_table').find('[id^="head"]').each(function(){
        var title = $(this).html();
        var cls = '';
        var colIdx = this.id.replace('head', '');
        if ($.inArray(title, ['주간추가1']) != -1) cls = 'sp1';
        else if ($.inArray(title, ['야간추가1']) != -1) cls = 'sp2';
        else if ($.inArray(title, ['주간4','주간5','주간6']) != -1) cls = 'sp3';
        else if ($.inArray(title, ['야간4','야간5','야간6']) != -1) cls = 'sp4';
        else if ($.inArray(title, ['야간10','야간11','야간12']) != -1) cls = 'sp5';
        else if ($.inArray(title, ['6톤','7.5톤','10톤']) != -1) cls = 'sp4';
        else if ($.inArray(title, ['17.5톤','20톤']) != -1) cls = 'sp5';

        if (cls) {
            $('#price_table tr').each(function(){
                $(this).find(`td:eq(${colIdx})`).find('input').addClass(cls);
            });
        }
    });
}

function editOption(num, priceType, name){
    if (!priceType) {
        $j.F.Admin.Util.tsalert('error', '설정하실수없습니다.');
        return;
    }
    var adr = `/adm/car-option-method-price?n=${num}`;
    var title = `옵션설정 : ${carType} > ${name}`;
    if (priceType == 5) {
        adr = `/adm/car-option-prices?n=${num}`;
    }
    $j.Ui.JBModal.open('jb-modal-carprice', adr, null, {
        title: title,
        width: priceType == 5 ? '1400px' : '320px',
        onOpen: function($modal) {
            if (priceType == 5) initOptPriceModal($modal);
            else initMethodModal($modal);
        }
    });
}

/**
 * 옵션 연산방식+가격 설정 모달 (adm/pages/price/carOptionMethodPrice) — 방식(더하기 N회·1회·곱하기)과 항목별 값
 */
function initMethodModal($modal) {
    var $root = $modal.find('.carOptionMethodPrice');
    var option_num = $root.data('optionNum');
    var price_calc_type = String($root.data('calcType'));

    var db = {};
    function is_changed(id, p){ return db[id] != p; }

    $root.find('input[name="price_calc_type"][value="'+price_calc_type+'"]').prop('checked', true);
    $root.find('input[name="price_calc_type"]').on('change', set_price_unit);
    set_price_unit();

    $root.find('[id^="pr_"]').each(function(){
        db[this.id.replace('pr_','')] = $(this).val();
    }).on('blur', function(){
        var id = this.id.replace('pr_','');
        var price = $(this).val();
        if (isNaN(price) || price.indexOf('.') != -1 || price.length > 5 || price.length == 0) {
            $(this).val(db[id]);
            return;
        }
        if (is_changed(id, price)) $(this).css('color', 'var(--adm-kw-red, red)');
    });

    function set_price_unit(){
        var v = $root.find('input[name="price_calc_type"]:checked').val();
        $root.find('.unit_btn').html(v == 3 ? '배' : '만원');
    }

    $root.find('.com-save-btn').on('click', function(){
        var changed = [];
        $root.find('[id^="pr_"]').each(function(){
            var id = this.id.replace('pr_','');
            var price = $(this).val();
            if (is_changed(id, price)) changed.push(id + '=' + price);
        });
        $.ajax({
            type: 'POST',
            url: '/adm/ajax/car-option-method-price/save',
            data: {
                option_num: option_num,
                price_calc_type: $root.find('input[name="price_calc_type"]:checked').val(),
                prices: changed.join('&')
            },
            dataType: 'json',
            success: function(){
                $j.Common.Util.swalert(['저장완료', 'success'], function(){ location.reload(); });
            }
        });
    });
}

function initOptPriceModal($modal) {
    var $root = $modal.find('.carOptionPrices');
    var $table = $modal.find('#opt_price_table');
    var $chk = $modal.find('#opt_fold_chk');
    var priceDb = {};

    // 야간 컬럼 인덱스 수집
    var nightCols = [];
    $table.find('[id^="opt_head"]').each(function(){
        if ($(this).text().indexOf('야간') !== -1) {
            nightCols.push(parseInt(this.id.replace('opt_head', '')) + 1);
        }
    });

    // 야간접기/펴기
    function foldNight() {
        var hide = $chk.is(':checked');
        for (var i = 0; i < nightCols.length; i++) {
            var col = nightCols[i];
            $table.find('tr').each(function(){
                $(this).children().eq(col - 1).toggle(!hide);
            });
        }
    }

    $chk.on('change', foldNight);
    $chk.prop('checked', true);
    foldNight();

    // 배경색
    $table.find('[id^="opt_head"]').each(function(){
        var title = $(this).text();
        var cls = '';
        var col = parseInt(this.id.replace('opt_head', '')) + 1;
        if ($.inArray(title, ['주간추가1']) !== -1) cls = 'sp1';
        else if ($.inArray(title, ['야간추가1']) !== -1) cls = 'sp2';
        else if ($.inArray(title, ['주간4','주간5','주간6']) !== -1) cls = 'sp3';
        else if ($.inArray(title, ['야간4','야간5','야간6']) !== -1) cls = 'sp4';
        else if ($.inArray(title, ['야간10','야간11','야간12']) !== -1) cls = 'sp5';
        else if ($.inArray(title, ['6톤','7.5톤','10톤']) !== -1) cls = 'sp4';
        else if ($.inArray(title, ['17.5톤','20톤']) !== -1) cls = 'sp5';
        if (cls) {
            $table.find('tr').each(function(){
                $(this).children().eq(col - 1).find('input').addClass(cls);
            });
        }
    });

    // 가격 추적
    $table.find('[id^="pr_"]').each(function(){
        priceDb[this.id.replace('pr_', '')] = $(this).val();
    });
    $table.on('blur', '[id^="pr_"]', function(){
        var id = this.id.replace('pr_', '');
        var price = $(this).val();
        if (isNaN(price) || price.indexOf('.') !== -1 || price.length > 5 || price.length === 0) {
            $(this).val(priceDb[id]);
            return;
        }
        if (priceDb[id] != price) {
            $(this).css('color', 'var(--adm-kw-red, red)');
        }
    });

    // 저장 버튼
    $modal.find('.cop-save').on('click', function(){
        var changed_db = [];
        $table.find('[id^="pr_"]').each(function(){
            var id = this.id.replace('pr_', '');
            var price = $(this).val();
            if (priceDb[id] != price) {
                changed_db.push(id + '=' + price);
            }
        });
        if (changed_db.length === 0) {
            $j.Common.Util.swalert('변경사항이 없습니다.');
            return;
        }
        $.ajax({
            type: 'POST',
            url: '/adm/ajax/car-option-prices/save',
            data: {
                car_type: $root.data('carType') || carType,
                option_name: $root.attr('data-option-name') || '',
                price_calc_type: 1,
                prices: changed_db.join('&')
            },
            dataType: 'json',
            success: function(data){
                $j.Common.Util.swalert(['저장완료', 'success'], function(){ location.reload(); });
            }
        });
    });
}

async function editExcel(){
    var csv = '';
    var texts = [];
    $('#price_table td, th').each(function(){
        var html = $(this).html();
        if (html.indexOf('<input') != -1) {
            texts.push($(this).find('input').val());
        } else {
            if (texts.length > 0 && $(this).is('td')) {
                if (csv) csv += '\n';
                csv += texts.join('\t');
                texts = [];
            }
            texts.push(html);
        }
    });
    if (texts.length > 0) {
        csv += '\n' + texts.join('\t');
    }

    const text = await $j.Ui.Dialog.prompt('단가표 편집', {
        type:    'textarea',
        value:   csv,
        label:   '액셀로 복사해서 편집해주세요.',
        width:   '640px',
        confirm: '적용',
        cancel:  '취소',
    });
    applyExcel(text);
}

function applyExcel(csv){
    if (!csv) return;
    csv = csv.trim();
    var arr = csv.split('\n');
    var y = 0;
    arr.forEach(function(line){
        y++;
        if (y == 1) return;
        var cols = line.split('\t');
        var x = 0;
        cols.forEach(function(col){
            x++;
            if (x == 1) return;
            var kwd = `${x},${y}`;
            var $item = $(`input[data-value="${kwd}"]`);
            $item.val(col);
            checkPriceValue($item);
        });
    });
}
